import { Box } from "@mui/material"
import { MAP_INVENTORY_CONTAINER_ID } from "form/map/model"
import { createInventoryMap, destroyInventoryMap } from "form/map/tools/inventory"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ImpressionLegend } from "./ImpressionLegend"
import { InventoryMapButtons } from "./InventoryMapButtons"
import { InventoryMapLoader } from "./InventoryMapLoader"

export const InventoryMap = () => {
  React.useEffect(() => {
    createInventoryMap(MAP_INVENTORY_CONTAINER_ID)
    return () => destroyInventoryMap()
  })
  return (
    <FlexBox vertical sx={{ width: "100%", height: "100%", position: "relative" }}>
      <InventoryMapButtons />
      <Box
        id={MAP_INVENTORY_CONTAINER_ID}
        sx={{
          "width": "100%",
          "height": "100%",
          "& .mapbox-improve-map, & .mapboxgl-ctrl-logo": { display: "none" }
        }}
      />
      <InventoryMapLoader />
      <ImpressionLegend />
    </FlexBox>
  )
}
